<template>
  <fts-popper trigger="click" placement="bottom" :overlay="true" class="fts-ai-popup"
    :contentClass="'fts-ai-popup-content'" ref="popper" @show="isModalOpen" @hide="isModalClose">
    <!-- popup content -->
    <template #content>
      <div class="popup-content">
        <div class="gradient-background">
          <gradient-ai-background />
        </div>

        <div class="header-actions">
          <button class="nap-btn" @click="toggleGneyAiEnable">
            <font-awesome-icon class="moon" :icon="['fas', 'moon']" fixed-width />
            take a nap
          </button>
          <font-awesome-icon class="caret-down" :icon="['fas', 'caret-down']" fixed-width @click="isModalClose" />
        </div>

        <div class="gney-popup" v-if="thinking">
          <div class="chat-window">
            <!-- 用户消息 -->
            <div class="message user">
              <p>Help me to summarize</p>
            </div>

            <div class="shimmer-container">
              <div class="shimmer-box"></div>
              <div class="shimmer-box"></div>
              <div class="shimmer-box"></div>
            </div>
            <!-- AI thinking -->
            <div class="message ai">
              <fts-gney-ai class="ai-inline-thinking" :type="'thinking'" :size="40" />
              <p class="thinking">thinking...</p>
            </div>

            <!-- Footer -->
            <div class="popup-footer">
              <textarea class="input" id="message" v-model="message" rows="1" ref="textarea" @input="resize"
                placeholder="write something..."></textarea>

              <div class="footer-actions">
                <div class="left-icons">

                  <font-awesome-icon class="action-icon" :icon="['fas', 'paperclip']" fixed-width />
                  <font-awesome-icon class="action-icon" :icon="['fas', 'at']" fixed-width />
                </div>
                <button class="send-btn">
                  <font-awesome-icon :icon="['far', 'paper-plane']" fixed-width />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="gney-popup" v-else>
          <!-- Header -->
          <div class="popup-header">
            <fts-gney-ai class="ai-inline" :type="'idle'" />
          </div>

          <!-- Body -->
          <div class="popup-body">
            <!-- <gradient-ai-background class="gradient-background" /> -->
            <h3 class="title">I am GNey, how may i help you</h3>


            <div class="options">
              <div class="option">
                <font-awesome-icon class="moon" :icon="['fas', 'quote-left']" fixed-width />
                Summarize this form
              </div>
              <div class="option">
                <font-awesome-icon class="moon" :icon="['fas', 'pen']" fixed-width />
                Help me to fill the form
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="popup-footer">
            <textarea class="input" id="message" v-model="message" rows="1" ref="textarea" @input="resize"
              placeholder="write something..."></textarea>

            <div class="footer-actions">
              <div class="left-icons">

                <font-awesome-icon class="action-icon" :icon="['fas', 'paperclip']" fixed-width />
                <font-awesome-icon class="action-icon" :icon="['fas', 'at']" fixed-width />
              </div>
              <button class="send-btn" @click="onSend">
                <font-awesome-icon :icon="['far', 'paper-plane']" fixed-width />
              </button>
            </div>
          </div>
        </div>



      </div>

    </template>

    <!-- trigger button -->
    <div slot="reference" class="popup-trigger" :style="open ? { visibility: 'hidden', pointerEvents: 'none' } : {}">
      <slot name="trigger">
        <button class="btn">Open Popup</button>
      </slot>
    </div>
  </fts-popper>
</template>

<script>
import FTSPopper from "./FTSPopperNew";
import FTSGneyAi from "./FTSGneyAi";
import GradientAiBackground from './FTSGradientAiBackground.vue'

export default {
  components: {
    "fts-popper": FTSPopper,
    "fts-gney-ai": FTSGneyAi,
    "gradient-ai-background": GradientAiBackground,
  },
  data: () => ({
    thinking: false,
    open: false,
    message: "",
    maxLines: 10, // 最大行数
  }),
  methods: {
    isModalOpen() {
      console.log('here opend');
      this.open = true;
    },
    isModalClose() {
      console.log('here close');
      this.open = false;
      this.$refs.popper.doClose();
    },
    resize() {
      const el = this.$refs.textarea;
      if (!el) return;

      // 计算单行高度
      const lineHeight = parseInt(getComputedStyle(el).lineHeight, 10);

      // 允许的最大高度
      const maxHeight = this.maxLines * lineHeight;

      // 重置高度再计算
      el.style.height = "auto";
      el.style.overflowY = "hidden";

      if (el.scrollHeight > maxHeight) {
        el.style.height = maxHeight + "px";
        el.style.overflowY = "auto";
      } else {
        el.style.height = el.scrollHeight + "px";
      }
    },
    onSend() {
      this.thinking = !this.thinking;
    },
    toggleGneyAiEnable() {
      this.isModalClose();
      this.$emit("event:disable")
    }
  },
  mounted() {
    this.resize();
  },
}
</script>

<style>
.gradient-background {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
}

.fts-ai-popup {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  z-index: 2000;
}

.fts-ai-popup-content {
  padding-top: 0px;
  position: relative;
  bottom: 0px;
  right: 20px;
}

.gney-popup {
  padding: 30px 10px 0px 10px;
  width: 360px;
  display: flex;
  flex-direction: column;
}

/* header */
.popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}



.ai-inline {
  height: 40px;
  transform: scaleX(-1)
}



.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: radial-gradient(circle, #e5d4ff, #a3a8ff);
}

.header-actions {
  position: absolute;
  display: flex;
  top: 10px;
  right: 10px;
  gap: 4px;
}

.nap-btn {
  background: linear-gradient(90deg, #CFD8DC, #03A9F4, #3F51B5);
  border: none;
  border-radius: 20px;
  padding: 3px 6px 3px 2px;
  color: #fff;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  gap: 2px;
}

.nap-btn .moon {
  color: #FFD180;
}

.caret-down {
  color: #26323869;
  background-color: #2632380f;
  border-radius: 4px;
  padding: 2px;
  cursor: pointer;
}

.caret-down:hover {
  color: #000;
}

/* body */
.popup-body {
  margin-bottom: 20px;
  margin-left: 5px;
}

.title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px;

  background: linear-gradient(90deg, #6156E3, #B181EB);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.option {
  display: flex;
  gap: 6px;
  font-size: 12px;
  color: var(--fts-gray-600);
  padding-left: 4px;
}

/* footer */
.popup-footer {
  z-index: 10;
  border: 1px solid #eee;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
}

.input {
  outline: none;
  font-size: 14px;
  color: #444;
  font-family: inherit;
  line-height: 20px;
  resize: none;
  z-index: inherit;
  border: none;
  padding: 10px 10px 10px 10px;
  width: 100%;
}

.input::placeholder {
  color: #aaa;
  font-size: 14px;
}

.footer-actions {
  display: flex;
  z-index: inherit;
  /* background: #eee; */
  align-items: center;
  padding: 0px 5px 5px 10px;
  justify-content: space-between;
  cursor: pointer;
}


.left-icons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.send-btn {
  color: var(--fts-gray-400);
  background-color: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  padding: 6px 8px;
  cursor: pointer;
  z-index: inherit;
}

.action-icon {
  color: var(--fts-gray-400);
}

.action-icon:hover {
  color: var(--fts-primary);
}



/* inside */
.ai-inline-thinking {
  height: 40px;
  width: 40px;
  transform: scaleX(-1)
}

.chat-window {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 10px 0px;
  /* padding: 1rem; */
}

/* 用户消息 */
.message.user {
  align-self: flex-end;
  background: #f3f3f3;
  color: #000;
  padding: 0.5rem 0.75rem;
  border-radius: 1rem;
  max-width: 60%;
  margin-left: 20px;
}

/* AI 消息 */
.message.ai {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 20px;
}

/* AI 头像圆圈 */
.ai-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: conic-gradient(from 180deg, #a855f7, #3b82f6, #06b6d4);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 1.5s infinite;
}

/* thinking... 文字 */
.thinking {
  color: #999;
  font-style: italic;
}

/* 动画 */
/* @keyframes pulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.6;
    transform: scale(1.1);
  }
} */


/* shimmer */

.shimmer-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* spacing between boxes */
  margin-right: 20px;
}

.shimmer-box {
  height: 10px;
  /* adjust box height */
  border-radius: 6px;
  background: linear-gradient(90deg,
      #e0e0e0 25%,
      #f0f0f0 50%,
      #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }

  100% {
    background-position: 200% 0;
  }
}
</style>
